import Nullstack from 'nullstack';
export default function IconMathMin({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-math-min",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M12 17a2 2 0 1 1 0 4a2 2 0 0 1 0 -4z"
  }), "   ", Nullstack.element("path", {
    d: "M3 4c0 8.75 4 14 7 14.5"
  }), "   ", Nullstack.element("path", {
    d: "M14 18.5c3 -.5 7 -5.75 7 -14.5"
  }), " ");
}